import { render, staticRenderFns } from "./CollectionGrid.vue?vue&type=template&id=2c62687c&scoped=true&lang=pug&"
import script from "./CollectionGrid.vue?vue&type=script&lang=js&"
export * from "./CollectionGrid.vue?vue&type=script&lang=js&"
import style0 from "./CollectionGrid.vue?vue&type=style&index=0&id=2c62687c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c62687c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c62687c')) {
      api.createRecord('2c62687c', component.options)
    } else {
      api.reload('2c62687c', component.options)
    }
    module.hot.accept("./CollectionGrid.vue?vue&type=template&id=2c62687c&scoped=true&lang=pug&", function () {
      api.rerender('2c62687c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/collection/CollectionGrid.vue"
export default component.exports